<script>

import ImpersonateUserColumn from "../../../../frontend-admin/src/components/customColumns/ImpersonateUserColumn"

export default ImpersonateUserColumn
</script>